import React from "react";
import { useTranslation } from "react-i18next";
import MDialog from "@/components/ui/atoms/MDialog";

export interface DeleteMedicationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const DeleteMedicationModal: React.FC<DeleteMedicationModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const { t } = useTranslation();

  return (
    <MDialog
      isOpen={open}
      onClose={onClose}
      title={t("pillbox.deleteModal.title")}
      description={t("pillbox.deleteModal.description")}
      secondaryCtaText={t("common.cancel")}
      onSecondaryCta={onClose}
      primaryCtaText={t("common.delete")}
      onPrimaryCta={onConfirm}
      isPrimaryCtaLoading={loading}
    />
  );
};

export default DeleteMedicationModal;
